import { Component, OnInit, Input, Inject } from '@angular/core';
import { HttpService } from '../http.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  //hawkeyeUsers: Object;
  //_http: HttpService;

  constructor(@Inject(Router) _router: Router) {
    this.router = _router;
  }

  router: Router;
  navigation: any;

  authenticated: string = "";
  toggleChanged: boolean = false;
  sidebarOpen: boolean = false;

  toggleNav() {
    console.log(this.toggleChanged);
    this.toggleChanged = !this.toggleChanged;
    this.sidebarOpen = !this.sidebarOpen;
  }

  ngOnInit() {
    this.authenticated = sessionStorage.getItem('intcontId')
    console.log(this.authenticated);
    if (this.authenticated == "0") {
      this.router.navigate(['/', 'login']);
    }
    //this._http.getHawkeyeUsers().subscribe(users => {
    //  this.hawkeyeUsers = users;
    //  console.log(users);
    //})
  }

}
